/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Ui
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 11/21/17
 * Copyright All Rights Reserved
 */
import { combineReducers } from 'redux';
import {
  REQUEST_CREATE_SITE,
  REQUEST_CREATE_SITE_SUCCESS,
  REQUEST_CREATE_SITE_FAILURE,
  REQUEST_FETCH_REPORTS_SUCCESS,
} from 'constants/actionTypes';

const addToSitesById = (state, action) => {
// TODO: consider further what validation should occur here or in action creator
  const byId = {};
  byId[action.data.id] = action.data;
  return Object.assign({}, state, byId);
};

const mergeReports = (state, reports) => {
  const byId = {};
  reports.forEach((report) => { byId[report.id] = report; });
  return Object.assign({}, byId);
};

const sitesById = (state = {}, action) => {
  switch (action.type) {
    case REQUEST_CREATE_SITE:
      return state;
    case REQUEST_CREATE_SITE_SUCCESS:
      return addToSitesById(state, action);
    case REQUEST_CREATE_SITE_FAILURE:
      return state;
    case REQUEST_FETCH_REPORTS_SUCCESS:
      return mergeReports(state, action.data);
    default:
      return state;
  }
};

const loaded = (state = false, action) => {
  switch (action.type) {
    case REQUEST_FETCH_REPORTS_SUCCESS:
      return true;
    default:
      return state;
  }
};

const defaultCurrentSite = ({
  id: null,
  saving: false,
  error: null,
});

const currentSite = (state = defaultCurrentSite, action) => {
  switch (action.type) {
    case REQUEST_CREATE_SITE:
      return Object.assign({}, state, { id: null, error: null, saving: true });
    case REQUEST_CREATE_SITE_SUCCESS:
      return Object.assign({}, state, { id: action.data.id, error: null, saving: false });
    case REQUEST_CREATE_SITE_FAILURE:
      return Object.assign({}, state, { id: null, error: action.error, saving: false });
    default:
      return state;
  }
};

export default combineReducers({
  byId: sitesById,
  current: currentSite,
  loaded,
});
